import cn from "classnames";
import { BreadcrumbJsonLd } from "next-seo";
import Link from "next/link";
import { prepareJsonLdString } from "@/helpers/common";
import { BreadcrumbItem } from "@/types/shared";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import IconAngleRight from "public/img/icons/svg/angle-right-b.svg";

export type BreadcrumbsProps = {
  className?: string;
  list: BreadcrumbItem[];
  color?: "white" | "black";
};

export const Breadcrumbs = ({ list, className, color = "white" }: BreadcrumbsProps) => {
  const breadcrumbsList = list.map(({ name, ...rest }) => ({
    ...rest,
    name: prepareJsonLdString(name),
  }));

  return (
    <>
      <BreadcrumbJsonLd useAppDir itemListElements={breadcrumbsList} />
      <div className={cn("sc-breadcrumbs", `sc-breadcrumbs--color-${color}`, className)}>
        <ul className="sc-breadcrumbs__list">
          {list.map(({ position, name, item }, index) => (
            <li key={position} className="sc-breadcrumbs__item">
              {index !== list.length - 1 ? (
                <Link href={item} prefetch={false}>
                  {name}
                </Link>
              ) : (
                <span>{name}</span>
              )}
              {index !== list.length - 1 && <SpriteIcon width={15} height={15} icon={IconAngleRight} />}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Breadcrumbs;
